import React, { useCallback, useContext } from 'react'
import { navigate } from 'gatsby'
import { SideMenuContext } from '../../contexts/sideMenuContext'
import styles from './styles.module.css'
import Html from '../Html'

const UseCasesItem = ({ slug, title, description }) => {
  const { setSubmenu } = useContext(SideMenuContext)

  const onClick = useCallback(() => {
    setSubmenu('tutorials')
    navigate(slug)
  }, [slug])

  return (
    <button className={styles.useCasesItem} onClick={onClick}>
      <h3>{title}</h3>
      <Html as="p">{description}</Html>
    </button>
  )
}

export default UseCasesItem
